/// <amd-module name="Repos/Tfvc/Views/ShelvesetsHub/RestClient/Tfvc" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\tfvc\views\shelvesets-hub\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Tfvc from "Repos/Common/Contracts/Git";

export interface ITfvcRestClient extends IVssRestClient {
    /**
     * Get a single deep shelveset.
     * 
     * @param shelvesetId - Shelveset's unique ID
     * @param requestData - includeDetails, includeWorkItems, maxChangeCount, and maxCommentLength
     */
    getShelveset(shelvesetId: string, requestData?: Tfvc.TfvcShelvesetRequestData): Promise<Tfvc.TfvcShelveset>;
}

class TfvcRestClient extends RestClientBase implements ITfvcRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get a single deep shelveset.
     * 
     * @param shelvesetId - Shelveset's unique ID
     * @param requestData - includeDetails, includeWorkItems, maxChangeCount, and maxCommentLength
     */
    public async getShelveset(
        shelvesetId: string,
        requestData?: Tfvc.TfvcShelvesetRequestData
        ): Promise<Tfvc.TfvcShelveset> {

        const queryValues: any = {
            shelvesetId: shelvesetId,
            requestData: requestData
        };

        return this.beginRequest<Tfvc.TfvcShelveset>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/tfvc/shelvesets",
            queryParams: queryValues
        });
    }

}

export const TfvcClientName = "Repos.ShelvesetsHub.Tfvc.ITfvcRestClient";

export function getTfvcClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITfvcRestClient {
    return pageContext.getRestClient<ITfvcRestClient>(TfvcClientName, options);
}

RestClients.add(TfvcClientName, { 
    factory: TfvcRestClient,
    options: {
        resourceAreaId: "8aa40520-446d-40e6-89f6-9c9f9ce44c48",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
